import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Switch,
  IconButton,
  TextField,
  Checkbox,
  FormControlLabel,
  Avatar,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  ShoppingCart,
  Dashboard,
  People,
  BarChart,
  Layers,
  Settings,
  ArrowBackIos,
  ArrowForwardIos,
  ShoppingBasket,
  DeliveryDining,
  CurrencyRupeeRounded,
  CelebrationOutlined,
} from "@mui/icons-material";
import { Delete, UploadFile } from "@mui/icons-material";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import { convertYearMonthDateToMonthDateYear } from "../../utils/DateFormats";
import { useNavigate } from "react-router-dom";

const AdminProfile = ({ onBackScreenName }) => {
  const [data, setData] = useState([]);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [firstNameError, setFirstNameError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [genderError, setGenderError] = useState("");
  const [dobError, setDobError] = useState("");
  const [aadharNoError, setAadharNoError] = useState("");
  const [panNoError, setPanNoError] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const navigate = useNavigate();
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const userId = userDetails ? userDetails["user_id"] : null;

  const clearErrors = () => {
    setFirstNameError("");
    setMobileNoError("");
    setEmailError("");
    setRoleError("");
    setStatusError("");
    setGenderError("");
    setDobError();
    setAadharNoError("");
    setPanNoError("");
    setOldPasswordError("");
    setNewPasswordError("");
  };

  // const {
  //   data: usersWithIdData,
  //   isLoading: isUsersWithIdDataLoading,
  //   error: usersWithIdError,
  //   fetchData: fetchusersWithIdData,
  // } = useFetch(BASE_URL_TEST + urls("findById", userId), {
  //   method: "GET",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: loginToken ? `Bearer ${loginToken}` : "",
  //   },
  // });

  const {
    data: updateUsersData,
    isLoading: updateUsersLoading,
    error: updateUsersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: passwordChangeData,
    isLoading: ispasswordChangeDataLoading,
    error: passwordChangeDataError,
    fetchData: fetchCreatePasswordChange,
  } = useFetch(BASE_URL_TEST + urls("changePassword"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const genderChecked = {
    male: userDetails["gender"] === "male",
    female: userDetails["gender"] === "female",
  };
  const [profileData, setProfileData] = useState({
    profilePhoto: userDetails["profile"] ? userDetails["profile"] : "",
    firstName: userDetails["first_name"] ? userDetails["first_name"] : "",
    lastName: userDetails["last_name"] ? userDetails["last_name"] : "",
    mobileNo: userDetails["mobile_number"] ? userDetails["mobile_number"] : "",
    email: userDetails["email"] ? userDetails["email"] : "",
    role: userDetails["role_name"] ? userDetails["role_name"] : "",
    gender: userDetails["gender"] ? userDetails["gender"] : "",
    dob: userDetails["dob"]
      ? convertYearMonthDateToMonthDateYear(userDetails.dob)
      : "",
    aadharNo: userDetails["aadhar_number"] ? userDetails["aadhar_number"] : "",
    panNo: userDetails["pan_number"] ? userDetails["pan_number"] : "",
    genderChecked,
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
  });

  // useEffect(() => {
  //   if (usersWithIdError) {
  //   } else if (usersWithIdData && usersWithIdData["status"] === true) {
  //     console.log("usersWithIdData", usersWithIdData["data"]);
  //     setData(usersWithIdData["data"]);
  //   }
  // }, [usersWithIdData, usersWithIdError]);

  //Update User
  useEffect(() => {
    if (updateUsersError) {
    } else if (updateUsersData && updateUsersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateUsersData["message"],
        status: updateUsersData["status"],
      });
      setModalOpen(true);
      // fetchusersWithIdData();
    } else if (updateUsersData && updateUsersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateUsersData["message"],
        status: updateUsersData["status"],
      });
      setModalOpen(true);
      // fetchusersWithIdData();
    }
  }, [updateUsersData, updateUsersError]);

  //Change Password
  useEffect(() => {
    if (passwordChangeDataError) {
    } else if (passwordChangeData && passwordChangeData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: passwordChangeData["message"],
        status: passwordChangeData["status"],
      });
      setModalOpen(true);
    } else if (passwordChangeData && passwordChangeData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: passwordChangeData["message"],
        status: passwordChangeData["status"],
      });
      setModalOpen(true);
    }
  }, [passwordChangeData, passwordChangeDataError]);

  const handleProfileUpdate = () => {
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const aadharRegex = /^\d{12}$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    const validateField = (field, value, regex, errorSetter, errorMessage) => {
      const stringValue = value ? String(value).trim() : "";
      if (!stringValue) {
        errorSetter(errorMessage);
        return false;
      }
      if (regex && !regex.test(stringValue)) {
        errorSetter(errorMessage);
        return false;
      }
      return true;
    };

    const validateAllFields = () => {
      clearErrors();
      if (
        !validateField(
          "firstName",
          profileData["firstName"],
          null,
          setFirstNameError,
          "First name is required."
        )
      )
        return false;
      if (
        !validateField(
          "mobileNo",
          profileData["mobileNo"],
          mobileRegex,
          setMobileNoError,
          "Please enter a valid 10-digit mobile number."
        )
      )
        return false;
      if (
        !validateField(
          "email",
          profileData["email"],
          emailRegex,
          setEmailError,
          "Please enter a valid email address."
        )
      )
        return false;
      if (
        !validateField(
          "gender",
          profileData.gender,
          null,
          setGenderError,
          "Please select gender."
        )
      )
        return false;

      if (
        !validateField(
          "aadharNo",
          profileData["aadharNo"],
          aadharRegex,
          setAadharNoError,
          "Aadhar number must be 12 digits."
        )
      )
        return false;
      if (
        !validateField(
          "panNo",
          profileData["panNo"],
          panRegex,
          setPanNoError,
          "Please enter a valid PAN number."
        )
      )
        return false;

      return true;
    };

    const formdata = new FormData();
    if (validateAllFields()) {
      // If all validations pass, prepare the formdata for either create or update
      console.log("Validation Passed, Proceeding with formdata");

      formdata.append("first_name", profileData["firstName"]);
      formdata.append("last_name", profileData["lastName"]);
      formdata.append("mobile_number", profileData["mobileNo"]);
      formdata.append("email", profileData["email"]);
      formdata.append("gender", profileData["gender"]);
      formdata.append("dob", profileData.dob ? profileData.dob : null);
      formdata.append("aadhar_number", profileData["aadharNo"]);
      formdata.append("pan_number", profileData["panNo"]);
      formdata.append(
        "profile",
        selectedProfileFile ? selectedProfileFile : profileData["profilePhoto"]
      );

      // Edit Mode (Update user data)
      formdata.append("role_id", userDetails["role_id"]);
      formdata.append("status", 1);
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      const updateUrl = urls("updateUsers", userId);
      fetchUpdateData(updateUrl, formdata);
    }
  };
  const handleSubmit = () => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/;

    const validateField = (field, value, regex, errorSetter, errorMessage) => {
      const stringValue = value ? String(value).trim() : "";
      if (!stringValue) {
        errorSetter(errorMessage);
        return false;
      }
      if (regex && !regex.test(stringValue)) {
        errorSetter(errorMessage);
        return false;
      }
      return true;
    };

    const validateAllFields = () => {
      clearErrors();

      if (!passwordData.oldPassword) {
        setOldPasswordError("Old Password is required.");
        return false;
      }
      if (!passwordData.newPassword) {
        setNewPasswordError("Confirm Password is required.");
        return false;
      }
      if (
        !validateField(
          "password",
          passwordData["newPassword"],
          passwordRegex,
          setNewPasswordError,
          "Confirm Password must be between 8-20 characters, include uppercase, lowercase, a number, and a special character."
        )
      )
        return false;

      return true;
    };

    if (validateAllFields()) {
      console.log(
        "Validation Passed, Proceeding with formdata",
        userDetails.user_id,
        passwordData["oldPassword"],
        passwordData["newPassword"]
      );
      const saveBody = {
        id: userDetails.user_id,
        oldpassword: passwordData["oldPassword"],
        newpassword: passwordData["newPassword"],
      };

      fetchCreatePasswordChange(saveBody);
    }
  };

  // Handle Gender checkbox
  const handleGenderChange = (e) => {
    const { name, checked } = e.target;
    setProfileData((prevValues) => ({
      ...prevValues,
      gender: checked ? name : "",
    }));
  };

  const handleProfileImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileData({
        ...profileData,
        profilePhoto: URL.createObjectURL(file),
      });
      setSelectedProfileFile(file);
    }
  };

  //Password
  const handlePasswordChange = (e) => {
    const oldPassword = e.target.value;
    setPasswordData({ ...passwordData, oldPassword: oldPassword });
  };
  //Confirm password
  const handleConfirmPasswordChange = (e) => {
    const newPassword = e.target.value;
    setPasswordData({ ...passwordData, newPassword: newPassword });
  };
  const handlePasswordVisibilityToggle = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleConfirmPasswordVisibilityToggle = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };
  //close button
  const handleClose = () => {
    setModalOpen(false);
    clearErrors();
    setSnackbarState({
      message: "",
      status: "",
    });
  if (passwordChangeData && passwordChangeData["status"] === true) {
  navigate("/admin-login");
}
if (updateUsersData && updateUsersData["status"] === true) {
  navigate("/dashboard"); 
}
  };

  return (
    <Box>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          padding: 2,
          maxWidth: 1200,
          margin: "auto",
          backgroundColor: "#fff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          mt: 3,
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          General information
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Fill an employee’s general info such as name, address number
        </Typography>

        {/* Profile Photo Section */}
        <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
              Photo Profile
            </Typography>
            <Avatar
              alt="Profile"
              src={profileData?.profilePhoto || "/default-profile.png"}
              sx={{ width: 100, height: 100, border: "2px solid #ddd", mb: 1 }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Button
              variant="contained"
              component="label"
              startIcon={<UploadFile />}
              sx={{
                mr: 2,
                bgcolor: "#3f51b5",
                "&:hover": { bgcolor: "#303f9f" },
              }}
            >
              Upload Image
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleProfileImage}
              />
            </Button>
            <Button
              variant="outlined"
              startIcon={<Delete />}
              onClick={() => {
                setProfileData((prevData) => ({
                  ...prevData,
                  profilePhoto: "",
                }));
              }}
              sx={{
                color: "#f44336",
                borderColor: "#f44336",
                "&:hover": { bgcolor: "#ffe6e6" },
              }}
            >
              Delete
            </Button>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="First Name"
              value={profileData?.firstName}
              onChange={(e) =>
                setProfileData({
                  ...profileData,
                  firstName: e.target.value,
                })
              }
              error={!!firstNameError}
              helperText={
                firstNameError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {firstNameError}
                  </Typography>
                )
              }
              sx={{ mb: 2 }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Last Name"
              value={profileData.lastName}
              onChange={(e) =>
                setProfileData({
                  ...profileData,
                  lastName: e.target.value,
                })
              }
              sx={{ mb: 2 }}
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Phone Number"
              value={profileData.mobileNo}
              onChange={(e) =>
                setProfileData({ ...profileData, mobileNo: e.target.value })
              }
              error={!!mobileNoError}
              helperText={
                mobileNoError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {mobileNoError}
                  </Typography>
                )
              }
              sx={{ mb: 2 }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Email"
              value={profileData.email}
              onChange={(e) =>
                setProfileData({ ...profileData, email: e.target.value })
              }
              error={!!emailError}
              helperText={
                emailError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {emailError}
                  </Typography>
                )
              }
              sx={{ mb: 2 }}
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontWeight: "bold" }}>Select Gender</Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={profileData.gender === "male"}
                  onChange={handleGenderChange}
                  name="male"
                />
              }
              label={<Typography variant="body2">Male</Typography>}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={profileData.gender === "female"}
                  onChange={handleGenderChange}
                  name="female"
                />
              }
              label={<Typography variant="body2">Female</Typography>}
            />
            {genderError && (
              <Typography
                sx={{ textAlign: "left", marginTop: 1, color: "red" }}
              >
                {genderError}
              </Typography>
            )}
          </Box>

          <Box sx={{ flex: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Date of Birth"
                value={profileData.dob ? new Date(profileData.dob) : null}
                maxDate={new Date()}
                onChange={(newValue) => {
                  setProfileData({ ...profileData, dob: newValue });
                }}
                error={!!dobError}
                helperText={
                  dobError ? (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                      }}
                    >
                      {dobError}
                    </Typography>
                  ) : (
                    ""
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}></Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Aadhar Number"
              value={profileData.aadharNo}
              onChange={(e) =>
                setProfileData({ ...profileData, aadharNo: e.target.value })
              }
              error={!!aadharNoError}
              helperText={
                aadharNoError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {aadharNoError}
                  </Typography>
                )
              }
              sx={{ mb: 2 }}
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Pan Number"
              value={profileData.panNo}
              onChange={(e) =>
                setProfileData({ ...profileData, panNo: e.target.value })
              }
              error={!!panNoError}
              helperText={
                panNoError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {panNoError}
                  </Typography>
                )
              }
              sx={{ mb: 2 }}
            />
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          {/* <Button onClick={() => setOpenDialog(false)}>Reset</Button> */}
          <Button
            variant="contained"
            color="success"
            onClick={handleProfileUpdate}
          >
            Update
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          padding: 2,
          maxWidth: 1200,
          margin: "auto",
          backgroundColor: "#fff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          mt: 3,
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 0 }}>
          Account Information
        </Typography>
        <Typography variant="body2" color="textSecondary">
          This info will need for employee's future login
        </Typography>

        {/* <Box sx={{ flex: 1 }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Email"
            value={profileData.email}
            onChange={(e) =>
              setProfileData({ ...profileData, email: e.target.value })
            }
            sx={{ mb: 2 }}
          />
        </Box> */}

        <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
          <Grid item xs={12}>
            <TextField
               label="Old Password" 
              type={isPasswordVisible ? "text" : "password"}
              value={passwordData.oldPassword}
              onChange={handlePasswordChange}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={handlePasswordVisibilityToggle}>
                    {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
              error={!!oldPasswordError}
              helperText={
                oldPasswordError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {oldPasswordError}
                  </Typography>
                )
              }
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="New Password"  
              type={isConfirmPasswordVisible ? "text" : "password"}
              value={passwordData.newPassword}
              onChange={handleConfirmPasswordChange}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={handleConfirmPasswordVisibilityToggle}>
                    {isConfirmPasswordVisible ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                ),
              }}
              error={!!newPasswordError}
              helperText={
                newPasswordError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {newPasswordError}
                  </Typography>
                )
              }
              variant="outlined"
            />
          </Grid>
        </Box>

        <Box sx={{ mt: 2 }}>
          {/* <Button onClick={() => setOpenDialog(false)}>Reset</Button> */}
          <Button variant="contained" color="success" onClick={handleSubmit}>
            Update
          </Button>
        </Box>
      </Box>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminProfile;
